import { Injectable } from '@angular/core';
import { URLSearchParams,Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {ApiService} from '../../../shared/services/api.service';
import { RequestOptions, Request, RequestMethod } from '@angular/http';

@Injectable()
export class TemplateService {
  baseFolder = "ENCollectCapFirstDev"
  baseURL = this.baseFolder + "/api/mvp"
  constructor(
    private apiService: ApiService
  ) { }

	 fetchTabs() {
		return this.apiService.get('/api/mvp/dfb/get/tabs')
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	 fetchSections() {
		return this.apiService.get('/api/mvp/dfb/get/getDFBSections')
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchGroups() {
		return this.apiService.get('/api/mvp/dfb/get/getDFBGroups')
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchFields() {
		return this.apiService.get('/api/mvp/dfb/get/getDFBFields')
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchTemplates() {
		return this.apiService.get('/api/mvp/dfb/get/getDFBTemplates')
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchTemplateById(templateId) {
		return this.apiService.get('/api/mvp/dfb/get/getDFBTemplate/?id='+templateId)
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchFieldsOfGroup(groupId) {
		return this.apiService.get('/api/mvp/dfb/get/group/Id/?groupId='+groupId)
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchFieldsDetailsOfGroup(fieldId) {
		return this.apiService.get('/api/mvp/dfb/get/getDFBField?id='+fieldId)
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchTabDetail(tabID) {
		return this.apiService.get('/api/mvp/dfb/get/tab/Id/?tabId='+tabID)
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchSectionDetail(sectionID) {
		return this.apiService.get('/api/mvp/dfb/get/DFBSection/?id='+sectionID)
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	  fetchGroupDetailsOfSection(groupId) {
		return this.apiService.get('/api/mvp/dfb/get/group/Id/?groupId='+groupId)
		  .map(
		  data => {
			return data;
		  }
		  );
	  }
	  
	createTemplate(data) {
		return this.apiService.post('/api/mvp/dfb/add/template', data)
		  .map(
			(response: Response) => {
			  return response;
			}
		  )
		  .catch(
			(error: Response) => {
			  return Observable.throw('Something went wrong');
			}
		  );
	}
	editTemplate(data) {
		return this.apiService.post('/api/mvp/edit/dfbTemplate', data)
		  .map(
			(response: Response) => {
			  return response;
			}
		  )
		  .catch(
			(error: Response) => {
			  return Observable.throw('Something went wrong');
			}
		  );
	}
  }


// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/template.service.ts